export default __webpack_public_path__ + "static/media/ppc.19487d89.jpg";